/**
 * Marks a browser as belonging to an editor, so `DraftModeToggle` knows to
 * render even while draft mode is off. Deliberately not httpOnly, because the
 * toggle is a client component and reading cookies on the server would opt every
 * page out of static generation. It grants nothing on its own.
 */
export const EDITOR_MARKER_COOKIE = "binarly_editor";
